import { render, staticRenderFns } from "./BarTop.vue?vue&type=template&id=048e587a&scoped=true"
import script from "./BarTop.vue?vue&type=script&lang=js"
export * from "./BarTop.vue?vue&type=script&lang=js"
import style0 from "./BarTop.vue?vue&type=style&index=0&id=048e587a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e587a",
  null
  
)

export default component.exports